




































































































import { Component, Inject, Mixins } from "vue-property-decorator";
import { ValidationObserver } from "vee-validate/dist/types/components/Observer.d";
import HasValidation from "@/mixins/HasValidation";
import {
  IFraudMindProvider,
  IFraudMindProviderMethods
} from "@/models/providers/fraud";
import { FraudStatusMap } from "@/data/fraud";
import FraudEventsTable from "@/components/app/global/fraud/fraudEventsTable.vue";
import FraudPolicySelect from "@/components/app/global/fraud/fraudPolicySelect.vue";

@Component({
  components: {
    FraudPolicySelect,
    FraudEventsTable
  }
})
export default class FraudAnalysisModal extends Mixins(HasValidation) {
  public $refs!: {
    fraudEventsTable: FraudEventsTable;
    observer: InstanceType<typeof ValidationObserver>;
  };
  // Inject
  @Inject({ from: "fraudMindProvider" })
  public $fraudProvider!: () => IFraudMindProvider;
  @Inject({ from: "fraudMindProviderMethods" })
  public $fraudMethods!: IFraudMindProviderMethods;
  // Data
  public isLoading = true;
  public FraudStatusMap = FraudStatusMap();
  // Life-cycle methods
  public async created() {
    try {
      this.isLoading = true;
      await this.$fraudMethods.getClientPolicy();
    } finally {
      this.isLoading = false;
    }
  }
  // Computed
  public get fraudProvider() {
    return this.$fraudProvider();
  }
  public get fraudStatuses() {
    return this.$_.orderBy(this.FraudStatusMap, ["id", "asc"]);
  }
  public get localisedFraudObj() {
    return (this.$t(`_.${this.fraudProvider.type}`) as string).toLowerCase();
  }
  // Methods
  public async changeStatus(statusId) {
    await this.$fraudMethods.changeStatus(statusId);
    this.$refs.fraudEventsTable.getData({ ignoreStored: true });
  }
}
